<mat-dialog-content>
  <div class="grid place-items-center">
    <div class="grid text-white">
      <mat-spinner [strokeWidth]="2" [diameter]="32"></mat-spinner>
      <div class="mt-3 text-xl">{{'loading-initial-data.info' | translate}}</div>
      <div class="mt-3">{{'loading-initial-data.hint' | translate}}</div>
    </div>
  </div>
</mat-dialog-content>
